<template>
  <!--底部内容-->
  <footer class="footer-box">
    <div class="footer-info">
      <div class="footer-content">
        <h3 class="footer-title">contact details</h3>
        <p>Welcome to contact us and leave your suggestion</p>
        <p>Tel：{{homePage.phone}}</p>
        <p>Mail：{{homePage.email}}</p>
        <p>Website：{{homePage.website}}</p>
      </div>
      <div class="footer-content">
        <h3 class="footer-title">Products Recommended</h3>
        <p v-for="classify in classifys"><a :href="'http://www.yuanwhite.com/#/shopping?classifyId='+classify.id+'&name='+classify.name">{{classify.name}}</a></p>
      </div>
      <div class="footer-content">
        <h3 class="footer-title"><a href="http://www.yuanwhite.com/#/msgBoard">Online declaration</a></h3>
        <p><el-input v-model="info" placeholder="Please enter the product you are interested in"></el-input></p>
        <p><el-input v-model="phone" placeholder="please leave your phone number"></el-input></p>
        <p><el-button type="primary" plain @click="ok()">submit</el-button></p>
        <!-- <a href="http://beian.miit.gov.cn" class="footer-record">Copyright2019-2022 Record number: Shanghai ICP No. 15057162-7</a> -->
      </div>

    </div>
  </footer>
</template>

<script>
import { getLowerClassify,addMsg,getHomePage } from '../api/api'
export default {
  data () {
    return {
      classifys:[],
      info:"",
      phone:"",
      homePage:{
      },
    }
  },
  methods: {
    getClassify(){
      var that = this;
      let param = {
        id: 2
      }
      getLowerClassify(param).then(res => {
        that.classifys=res.data;
        console.log(that.classifys)
      });
    },
    getHomePage(){
      var that = this;
      getHomePage().then(res => {
        that.homePage=res.data;
      });
    },
    ok () {
      var that = this;
      let param = {
        phone: that.phone,
        info: that.info,
      }
      if (param.phone == null || param.phone == ''||param.info == null || param.info == '') {
        that.$message({
          message:"Please fill in the required (*required) information!",
          type:"warning"
        })
      } else {
        addMsg(param).then((res) => {
          that.$message({
            message:res.data,
            type:"success"
          })
          that.phone="";
          that.info="";
        })
      }
    },
  },
  mounted () {
    let that = this;
    that.getClassify();
    that.getHomePage();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bottom.vue